import { render, staticRenderFns } from "./Method-envios.vue?vue&type=template&id=e9090e84&scoped=true"
import script from "./Method-envios.vue?vue&type=script&lang=js"
export * from "./Method-envios.vue?vue&type=script&lang=js"
import style0 from "./Method-envios.vue?vue&type=style&index=0&id=e9090e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9090e84",
  null
  
)

export default component.exports